'use client'

import Script from 'next/script'

export function GoogleMerchantBadge() {
  return (
    <>
      <Script 
        id="merchantWidgetScript" 
        src="https://www.gstatic.com/shopping/merchant/merchantwidget.js" 
        strategy="lazyOnload" 
        onLoad={() => {
          if (typeof window !== 'undefined' && (window as any).merchantwidget) {
            ;(window as any).merchantwidget.start({
              merchant_id: 5757667852,
              position: 'BOTTOM_LEFT', // Can be BOTTOM_LEFT or BOTTOM_RIGHT
            })
          }
        }}
      />
    </>
  )
}
